var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoactivity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2.5,
    width: 28,
    height: 23,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5H18.5H22.5L23.5 22.5H34.5",
    stroke: "url(#paint0_linear_1872_138514)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.5H20.5H24L24.5 18L26 17L27 20.5H34.5",
    stroke: "url(#paint1_linear_1872_138514)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4631 7.91995H28.0565C28.4657 7.91995 28.7078 8.10367 28.7078 8.41207C28.7078 8.71719 28.4521 8.9206 28.0701 8.9206C27.6472 8.9206 27.388 8.72703 27.3778 8.41207H26C26.0477 9.37664 26.8458 10 28.0394 10C29.3456 10 30.1777 9.43898 30.1777 8.55315C30.1777 7.90682 29.7037 7.49672 28.9807 7.42126V7.39501C29.5741 7.29331 30.0072 6.87992 30.0072 6.30906C30.0072 5.50853 29.2706 5.00328 28.1076 5.00328C26.8969 5.00328 26.0955 5.62992 26.0921 6.57808H27.3948C27.3948 6.24672 27.6574 6.01706 28.0462 6.01706C28.4418 6.01706 28.6772 6.20079 28.6772 6.49934C28.6772 6.80118 28.4418 6.98819 28.0633 6.98819H27.4631V7.91995Z",
    fill: "#CC3366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8344 10C34.1645 10 35 9.04856 35 7.48688C35 5.91207 34.1542 5 32.8344 5C31.5146 5 30.6654 5.91535 30.6654 7.49016C30.6654 9.05512 31.5044 10 32.8344 10ZM32.8344 8.93045C32.432 8.93045 32.1387 8.46457 32.1387 7.49016C32.1387 6.51247 32.432 6.06955 32.8344 6.06955C33.2368 6.06955 33.5267 6.51247 33.5267 7.49016C33.5267 8.46457 33.2368 8.93045 32.8344 8.93045Z",
    fill: "#CC3366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24121 20.5H8.84473V10.7969H5.24121V20.5ZM7.04297 10.2607C8.0625 10.2607 8.83594 9.52246 8.83594 8.55566C8.83594 7.58887 8.0625 6.85059 7.04297 6.85059C6.02344 6.85059 5.25 7.58887 5.25 8.55566C5.25 9.52246 6.02344 10.2607 7.04297 10.2607ZM10.1982 20.5H13.8018V10.7969H10.1982V20.5ZM12 10.2607C13.0195 10.2607 13.793 9.52246 13.793 8.55566C13.793 7.58887 13.0195 6.85059 12 6.85059C10.9805 6.85059 10.207 7.58887 10.207 8.55566C10.207 9.52246 10.9805 10.2607 12 10.2607ZM15.1553 20.5H18.7588V10.7969H15.1553V20.5ZM16.957 10.2607C17.9766 10.2607 18.75 9.52246 18.75 8.55566C18.75 7.58887 17.9766 6.85059 16.957 6.85059C15.9375 6.85059 15.1641 7.58887 15.1641 8.55566C15.1641 9.52246 15.9375 10.2607 16.957 10.2607Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1872_138514",
    x1: 22,
    y1: 9,
    x2: 33.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1872_138514",
    x1: 22,
    y1: 9,
    x2: 33.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669966"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoactivity);
export default __webpack_public_path__ + "static/media/noactivity.307ecb3494322972f1d43016f4656eed.svg";
export { ForwardRef as ReactComponent };